class Dropdown {
    constructor(element, options) {
        this.element = element;
        this.options = options;

        this._init();
    }

    _init() {
        this._setInitialProperties();
        this._cacheSelectors();
        this._bindEvents();
    }

    _setInitialProperties() {
        this.elements = {};
        this.list = [];
    }

    _cacheSelectors() {
        const { element } = this;

        this.elements = {
            canvas: document.body,
            counter: element.querySelector('.dropdown__counter'),
            placeholder: element.querySelector('.dropdown__placeholder'),
            options: element.querySelectorAll('.dropdown__checkbox')
        }
    }

    _bindEvents() {
        const { element } = this;
        const { canvas, options } = this.elements;

        element.addEventListener('click', this._handleClickOnElement.bind(this));
        canvas.addEventListener('click', this._handleClickOnCanvas.bind(this));
        [...options].map(option => option.addEventListener('click', this._handleClickOnOptions.bind(this)));
    }

    _handleClickOnElement(event) {
        const { element } = this;
        const { target: currentElement } = event;
        const isOpen = element.classList.contains('is-open')

        if(!isOpen && currentElement === element) {
            currentElement.classList.add('is-open');
        }

        if(isOpen && currentElement === element) {
            currentElement.classList.remove('is-open');
        }

        event.stopPropagation();
    }

    _handleClickOnCanvas() {
        const { element } = this;

        if(element.classList.contains('is-open')) {
            element.classList.remove('is-open');
        }
    }

    _handleClickOnOptions({currentTarget: element}) {
        const { value: option, checked } = element;
        const initialOptions = this.list;

        const selectedOptions = this._getSelectedOptions(option, checked, initialOptions);
        const count = this._getSelectedOptionsCount(selectedOptions);
        const lastSelectedOption = selectedOptions.slice(-1);

        this._updateCounter(count - 1);
        this._updatePlaceholder(count, lastSelectedOption);
        this._setSelectedOptions(selectedOptions);
    }

    _getSelectedOptions(option, checked = true, options) {
        if(checked) {
            options = [...options, option];
        } else {
            options = options.filter(item => item !== option);
        }

        return options;
    }

    _getSelectedOptionsValue(options) {
        return [...options].map(option => option.value);
    }

    _getSelectedOptionsCount(options) {
        return [...options].length;
    }

    _setSelectedOptions(value) {
        this.list = value;
    }

    _updateCounter(count) {
        const { counter } = this.elements;

        if(count < 1) {
            counter.classList.remove('is-visible');
        } else {
            counter.classList.add('is-visible');
            counter.innerHTML = `+${count}`;
        }
    }

    _updatePlaceholder(count, lastSelectedOption) {
        if(count === 0) {
            this._setPlaceholder('Maak een keuze');
        } else {
            this._setPlaceholder(lastSelectedOption);
        }
    }

    _setPlaceholder(value) {
        const { placeholder } = this.elements;

        placeholder.innerHTML = value;
    }
}
